import { render } from "./visitorsView.vue?vue&type=template&id=5cf8475d"
import script from "./visitorsView.vue?vue&type=script&lang=js"
export * from "./visitorsView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__